<template>
<div class='password-view login-form'>
  <div v-if='!mailSended'>
    <h1>{{$t('actions.findPassword.title')}}</h1>
    <el-form ref="form" :model="form" :rules="rules">
      <el-form-item style='text-align: left;'>
        <el-radio-group v-model="findType">
          <el-radio label="email">账号邮箱</el-radio>
          <el-radio label="cellphone">用户手机号</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- email way to find back -->
      <el-form-item prop="email" :error="errors.first('email')" v-if="findType === 'email'">
        <el-input v-model="form.email" :placeholder="$t('actions.findPassword.placeholder')">
        </el-input>
      </el-form-item>
      <!-- cellphone way to find back -->
      <!-- 手机号码 -->
      <cellphone-input ref="cellphoneInput" :cellphone.sync="cellphone" :captcha.sync="captcha" :reset="true" v-if="findType === 'cellphone'" />

      <el-form-item>
        <el-button type="primary submit-btn" @click='resetPassword()'>{{$t(`actions.findPassword.submit.${findType}`)}}
        </el-button>
      </el-form-item>

      <el-form-item>
        <router-link to="login">{{$t('actions.findPassword.returnLogin')}}</router-link>
      </el-form-item>
    </el-form>
  </div>
  <div v-else>
    <div class='password-sended img'></div>
    <h1 class='hint-title'>
        {{$t('actions.findPassword.sended.title', {email: form.email})}}
    </h1>
    <p class='hint'>{{$t('actions.findPassword.sended.hint')}}&nbsp;&nbsp;&nbsp;
      <router-link to="login" class='link'>{{$t('actions.findPassword.returnLogin')}}</router-link>
    </p>
  </div>
</div>
</template>

<style lang='scss' scoped>
.password-view {
    .password-sended {
        background-image: url("~@/assets/images/password-success.jpg");
        background-size: 100% 100%;
        width: 135px;
        height: 135px;
    }
}
</style>

<script>
import Validator from '@/mixins/validator'

export default {
  data() {
    return {
      findType: 'email', // or 'cellphone'
      form: {
        email: null
      },
      cellphone: null,
      captcha: null,
      mailSended: false
    }
  },
  mixins: [Validator],
  rules: {
    required: 'email',
    email: 'email'
  },
  methods: {
    resetPassword() {
      let vm = this
      let cellphoneInput = vm.$refs['cellphoneInput']

      let p1 = vm.findType === 'email' ? new Promise((resolve, reject) => {
        this.$refs['form'].validate(res => {
          res ? resolve() : reject('form')
        })
      }) : Promise.resolve()
      let p2 = vm.findType === 'cellphone' ? cellphoneInput.save() : Promise.resolve()

      Promise.all([p1, p2]).then(_ => {
        vm.$store.dispatch('user/reqResetPassword', {
          findType: vm.findType,
          email: vm.form.email,
          cellphone: vm.cellphone,
          captcha: vm.captcha
        }).then(res => {
          // depend on via attribute
          let data = res.data

          if (data.via === 'email') {
            vm.mailSended = true
          } else if (data.via === 'cellphone') {
            vm.$router.push({
              path: '/password/reset',
              query: {
                token: data.token
              }
            })
          }
        }).catch(err => {
          //   vm.errors.add('email', res.response.data.msg, 'custom_uplicate')
          let data = err.response.data
          if (data.type === 'EmailOrPhoneNotExistError') {
            // 邮箱不存在
            vm.findType === 'email' ? vm.errors.add('email', data.message) : cellphoneInput.addErrors('cellphone', data.message)
          } else if (data.type === 'CaptchaIncorrectError') {
            // 验证码错误
            cellphoneInput.addErrors('captcha', data.message)
          }
        })
      })
    }
  },
  beforeRouteLeave(to, from, next) {
    this.mailSended = false
    next()
  }
}
</script>



// WEBPACK FOOTER //
// password.view.vue?170a57ca